
<template>
  <div class="textfield cursor-pointer"
  :class="{
    active: valid,
    'has-reset': hasReset
  }"
  >
    <input 
    class="textfield-value"
    required
    :placeholder="(floatingLabel)?'':placeholder"
    ref="textfield"
    :type="type"
    :value="value"
    :readonly="isReadOnly"
    :disabled="isDisabled"
    @input="onInput"
    @focus="onFocus"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false">
    <label 
    v-if="floatingLabel"
    class="textfield-label no-select">{{ placeholder }}</label>
    <a class="btn clear"
    v-if="hasReset"
    @click.stop="reset">
      <i></i>
    </a>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    type: {
      default: 'text'
    },
    floatingLabel: {
      default: true
    },
    loading: {
      default: false
    },
    error: {
      default: false
    },
    validated: {
      default: undefined
    },
    hasReset: {
      default: false
    },
    isReadOnly: {
      default: false
    },
    isDisabled: {
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valid: function () {
      return (typeof this.validated !== 'undefined') ? this.validated : this.value !== ''
    }
  },

  methods: {
    onFocus (e) {
      var vm = this
      setTimeout(function () {
        vm.$emit('focus', e)
      })
    },

    onInput: function (e) {
      var vm = this
      // setTimeout(function () {
        // console.log('input', e.target.value)
        vm.$emit('input', e.target.value)
        // vm.$emit('input', vm.value)
      // })
    },

    reset: function () {
      var vm = this
      setTimeout(function () {
        vm.$emit('reset')
        vm.$emit('input', '')
      })
    },

    focus: function () {
      this.$refs.textfield.focus()
    }
  },

  mounted () {
  }

}
</script>
<style>
.textfield > input,
.textfield > textarea,
.textfield > .textfield-value {
  background: none;
  font-size: 0.9rem;
  max-width: 100%;
  border: 0;
  outline: 0;
  transition: all 0.3s;
  line-height: 1.45rem;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

.textfield {
  background: none;
  font-size: 0.9rem;
  max-width: 100%;
  margin-bottom: 2px;
  padding-bottom: 0.1rem !important;
  padding-top: 1.25rem !important;
  border: 0;
  outline: 0;
  transition: all 0.3s;
  border-bottom: 2px solid #eee;
}

.textfield:focus,
.textfield:hover,
.textfield.active {
  border-bottom: 2px solid #1976D2;
  border-bottom: 2px solid #4b96e0;
}

.textfield.has-error {
  border-bottom: 2px solid #db2828 !important;
}

label {
  font-size: 0.9rem;
}

.floating-label input:focus ~ label,
.floating-label input:valid ~ label,
.floating-label.active input ~ label,
.floating-label textarea:focus ~ label,
.floating-label textarea:valid ~ label,
.floating-label.active textarea ~ label,
.stacked-label input:focus + label,
.stacked-label textarea:focus + label {
  color: #1976D2;
}

.stacked-label label,
.floating-label label {
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  -webkit-transform-origin: left top;
          transform-origin: left top;
  color: rgba(0,0,0,0.54);
}

.stacked-label label {
  display: block;
  -webkit-transform: scale(0.8);
          transform: scale(0.8);
}

.stacked-label input {
  padding-top: 1.4rem;
}

.stacked-label textarea {
  margin-top: 1.4rem;
}

.textfield {
  padding: 8px 0px;
  line-height: 1.45rem;
  padding-bottom: 0.1rem;
}

.textfield {
  position: relative;
  display: inline-block;
}

.floating-label .textfield {
  padding-top: 1.25rem;
}
.floating-label > .textfield-value {
  line-height: 1.45rem;
  padding-bottom: 0.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.floating-label label {
  bottom: 8px;
  transition: color 0.3s, -webkit-transform 0.15s ease-in-out;
  transition: transform 0.15s ease-in-out, color 0.3s;
  transition: transform 0.15s ease-in-out, color 0.3s,
  -webkit-transform 0.15s ease-in-out;
  -webkit-transform: translateY(1.25rem) scale(1);
          transform: translateY(1.25rem) scale(1);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}

.textfield-value {
  width: 100%;
}

.textfield-label {
  display: none;
}

.floating-label .textfield-label {
  display: block;
}

.floating-label input:focus ~ label,
.floating-label input:valid ~ label,
.floating-label.active input ~ label,
.floating-label textarea:focus ~ label,
.floating-label textarea:valid ~ label,
.floating-label.active textarea ~ label {
  -webkit-transform: translateY(0) scale(0.8);
  transform: translateY(0) scale(0.8);
}

.has-reset.textfield { 
  padding-right: 30px;
}

.textfield .btn.clear0 {
  opacity: 0;
  transition: opacity 0.3s;
}

.textfield:hover .btn.clear {
  opacity: 1;
}

/*
.btn.clear {
  display: none !important;
}*/

</style>
